import React, { Suspense } from 'react'
import { CContainer, CSpinner } from '@coreui/react'
import { Outlet } from "react-router-dom";
import { useNavigation } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner'

const AppContent = () => {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  return (
    <CContainer fluid>
      <Suspense fallback={<CSpinner color="primary" />}>
        {isLoading 
        ? <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 186px)' }}>
          <ThreeDots 
              visible={true}
              height="90"
              width="90"
              color="black"
              radius="9"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
            /> </div> : <Outlet />}
      </Suspense>
    </CContainer>
  );
};

export default React.memo(AppContent);
